import { Component, ViewChild, HostListener, ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';

import { Actividad } from 'app/view/expo/expo';
import { MensajeService } from 'app/modulo_compartido/mensaje/mensaje.service';
import { DropService } from 'app/drags/type-check/drop-area-type-check/drop.service';

import { Usuario } from 'app/domain/usuario';

declare var $: any;
//import * as $ from 'jquery';

//import domains
import { Cliente, Liquidacion, Moneda, Comprobante, Maniefiesto, bl, tipos_bl, estados_liquidado, Busqueda, Contenedor, sendContenedor, ServicioAdicinal, Transportista, Cuadricula, Transaccion, NotaCredito, Pago, Cita, DetalleLiquidacion, Cupo, CitaSeparada, PDF } from './impo';

//import services
import { ImpoService } from './impo.service';
import { es, url_form } from 'app/domain/publico';

import { OnDestroy } from '@angular/core';

import { CSECoreService } from 'app/cse.coreService';

@Component({
	moduleId: module.id,
	selector: 'impo-app',
	templateUrl: 'impo.component.html',
	styleUrls: ['../../../assets/css/main.component.css'],
	providers: [ImpoService]
})

export class ImpoComponent implements OnDestroy {

	tipocliente: string = "";
	siguientetres: string = "";
	con_saldo: boolean = false;

	ls_detalleTransportista: any;

	constructor(private drop: DropService, private impo: ImpoService, private fb: FormBuilder, private sms: MensajeService, private _titulo: Title, private cseCore: CSECoreService) {
		this.ls_detalleTransportista = [];
		this.subscription = this.drop.getCupos().subscribe(resp => {
			if (resp) {
				resp.fecha = this.fecha_cita;
				this.cupos.push(resp);
				//console.log("nuevos cupós " + JSON.stringify(resp));
			}
		});

		this.subscription_delete = this.drop.getDelete().subscribe(resp => {
			if (resp) {
				//console.log("eliminando cupos " + JSON.stringify(resp));
				for (var i = 0; i < this.cupos.length; i++) {
					if (this.cupos[i].nroContenedor == resp.nroContenedor) {
						this.cupos.splice(i, 1);
					}
				}

				//console.log("agregando contenedores " + JSON.stringify(resp));
				for (var f = 0; f < this.ls_contenedores.length; f++) {
					if (this.ls_contenedores[f].nroContenedor == resp.nroContenedor) {
						this.ls_contenedores_detalle.push(this.ls_contenedores[f]);
					}
				}
			}
		});

	}


	ls_filtrados: any[];
	evaluar_filtro(value) {
		if (value == "" || value != this.valor_anterior) {
			this.busqueda.tipoBl = this.ls_tiposBL[0].codigo;
			this.busqueda.estadoBl = this.ls_liquidados[0].codigo;
			this.ls_manifiesto = new Array<Maniefiesto>();
		} else {
			this.valor_anterior = value;
		}
	}

	filtro_autocomplete(event) {
		this.ls_filtrados = [];
		if (this.ls_bl.length > 0)
			for (let i = 0; i < this.ls_bl.length; i++) {
				let numeroBl = this.ls_bl[i].documento;
				if (numeroBl.toUpperCase().search(event.toUpperCase()) == 0) {
					this.ls_filtrados.push(numeroBl);
				}
			}
	}

	brand: string = "";


	ls_filtrados_tr: any[];
	filtro_autocomplete_tr(data) {
		this.ls_filtrados_tr = [];
		if (this.ls_transportista.length > 0)
			for (let i = 0; i < this.ls_transportista.length; i++) {
				let brand = this.ls_transportista[i].rucEmpresa + '-' + this.ls_transportista[i].razonSocialEmpresa;
				if (brand.toUpperCase().search(data.query.toUpperCase()) == 0) {
					this.ls_filtrados_tr.push(brand);
				}
			}
	}

	cupos = new Array<any>();
	subscription: Subscription;
	subscription_delete: Subscription;

	private dropItemType: any;
	private dropItemTypeCheck(event, estado) {
		this.dropItemType = event;
		//console.log("agregado " + JSON.stringify(this.dropItemType), estado);
	}



	ls_citas: Array<Cita> = new Array<Cita>();
	ls_separadas: Array<CitaSeparada> = [];
	codigo_generar_cita: string = "";
	guardarCita(accion) {
		this.ls_separadas = [];
		////console.log(this.cupos);
		this.impo.generarCita(this.detalle_bl, this.cupos, this.detalle_contenedor, accion)
			.subscribe(resp => {

				this.cupos = new Array<any>();
				this.ls_separadas = resp;
				this.traerCita(this.fecha_cita);
				this.obtenerNumeroBl(this.detalle_bl, this.index_bl);

				if (accion == 1)
					this.success("--Cita correctamente programada--");
				if (accion == 2)
					this.success("--Cita correctamente reprogramada--");

				//Ya no es necesario volver a obtener el número BL .
				//this.obtenerNumeroBl(this.detalle_bl, this.index_bl);
				if (this.detalle_bl.codigoEstado == 5) {
					this.detalle_bl.codigoEstado = 6;
					this.detalle_bl.estado = "Planificado";
				}

			}, error => this.error(error))

	}

	cancelarCita() {
		$(".bd-example-modal-lg2").modal("hide");
		this.ls_contenedores_detalle = new Array<Contenedor>();
		for (var i = 0; i < this.ls_contenedores.length; i++) {
			this.ls_contenedores[i].check = false;
		}
		this.ls_separadas = [];
		this.cupos = [];
	}



	abrir_avanzado: boolean = false;
	busquedaAvanzada() {
		this.abrir_avanzado = !this.abrir_avanzado;
		this.busqueda.numeroBl = "";
		this.busqueda.tipoBl = this.ls_tiposBL[0].codigo;
		this.busqueda.manifiesto = "";
	}



	//LISTAS HARCORD
	ls_tiposBL = tipos_bl; //LISTA DE BLS
	ls_liquidados = estados_liquidado; //LISTA DE COMBO LIQUIDADOS 

	ls_bl: Array<bl> = [];
	ls_manifiesto: Array<Maniefiesto>;

	busqueda = new Busqueda();
	valor_anterior: string = "";
	tipo_busqueda = 1;

	BUSCAR(busqueda: Busqueda, tipo) {

		this.tipo_busqueda = tipo;
		if (tipo == 1) {
			busqueda.pagina = 1;
			this.pagina_actual = busqueda.pagina;
		}

		this.ls_bl = new Array<bl>();
		this.valor_anterior = busqueda.numeroBl;

		this.busqueda = busqueda;

		if (busqueda.numeroBl == "" && busqueda.estadoBl == "0" && tipo == 1) {
			this.alert("Debe seleccionar al menos un campo");
		} else {
			if (this.abrir_avanzado == true && tipo == 1) {
				if (busqueda.numeroBl != "") {
					this.obtenerBLDefecto(busqueda);
				}
				if (busqueda.estadoBl == "0") {
					//WEV_LIS_LIQUIDADOS
					//bl
					this.obtenerBLDefecto(busqueda);
				} else if (busqueda.fechainicio != "" && busqueda.fechafin == "") {
					this.alert("Debe ingresar una Fecha Valida");
				} else if (busqueda.fechainicio == "" && busqueda.fechafin == "") {
					//WEV_LIS_LIQUIDADOS
					//bl
					this.obtenerBLDefecto(busqueda);
				} else if (busqueda.fechainicio != "" && busqueda.fechafin != "") {
					//WEV_LIS_LIQUIDADOS
					//bl
					this.obtenerBLDefecto(busqueda);
				}
			} else if (this.abrir_avanzado == true || this.abrir_avanzado == false && tipo == 2) {
				this.obtenerBLDefecto(busqueda);
			} else if (this.abrir_avanzado == false && tipo == 1) {
				if (busqueda.numeroBl == "0") {
					this.alert("Debe ingresar el número BL")
				} else if (busqueda.tipoBl == "0") {
					this.alert("Debe seleccionar el tipo BL")
				} else {
					//WEV_LIS_CABBL
					//cabecera
					this.buscarBl(busqueda);
				}
			} else if (this.abrir_avanzado == false && tipo == 2) {
				this.buscarBl(busqueda);
			}
		}

	}

	obtenerBLDefecto(busqueda: Busqueda) {
		this.impo.getListaBlDefecto(busqueda)
			.subscribe(resp => {
				this.ls_bl = resp;
				this.carga_completa = true;


				if (this.ls_bl[0].documento == "") {
					this.ls_bl = new Array<bl>();
				}


				if (this.ls_bl.length > 0) {
					this.pagina_total = Number(this.ls_bl[0].paginas);
					this.total_item = Number(this.ls_bl[0].cantidad);
					this.crear_paginacion(this.pagina_total);
				}



				if (this.ls_bl.length > 0)
					if (this.liquidado == true && this.detalle_bl.documento != "") {
						this.encontrarNuevoBooking(this.detalle_bl);
						this.obtener_detalle_liquidacion(this.detalle_bl.transaccionId);
					}

			}, error => this.error(error));
	}

	buscarBl(busqueda: Busqueda) {
		this.impo.getListaBL(busqueda)
			.subscribe(resp => {
				this.ls_bl = resp;
				this.carga_completa = true;



				if (this.ls_bl[0].documento == "") {
					this.ls_bl = new Array<bl>();
				}

				if (this.ls_bl.length > 0) {
					this.pagina_total = Number(this.ls_bl[0].paginas);
					this.total_item = Number(this.ls_bl[0].cantidad);
					this.crear_paginacion(this.pagina_total);
				}

				if (this.ls_bl.length > 0)
					if (this.liquidado == true && this.detalle_bl.documento != "") {
						this.encontrarNuevoBooking(this.detalle_bl);
						this.obtener_detalle_liquidacion(this.detalle_bl.transaccionId);
					}

			}, error => this.error(error));
	}


	encontrarNuevoBooking(detalle_bk) {
		for (let i in this.ls_bl) {
			if (this.ls_bl[i].documento == detalle_bk.documento) {
				this.detalle_bl = this.ls_bl[i];
				this.obtenerNumeroBl(this.detalle_bl, i);
			}
		}
	}


	obtenerManifiesto(tipoBl, numeroBl) {
		if (numeroBl != "" && tipoBl != "0") {
			this.ls_manifiesto = [];
			this.impo.getManifiesto(numeroBl, tipoBl)
				.subscribe(resp => {
					this.ls_manifiesto = resp;
					this.seleccionarManifiesto(this.ls_manifiesto[0].anioManfiesto + "-" + this.ls_manifiesto[0].nroManifiesto)
				}, error => this.error(error))
		}
	}

	seleccionarManifiesto(valor) {
		this.busqueda.manifiesto = valor;
	}

	ls_contenedores: Array<Contenedor>;
	enviar: sendContenedor = new sendContenedor();

	abrir_detalle: boolean = false;
	abrir_detalle_info: boolean = false;
	detalle_bl: bl = new bl();
	index_bl = "";
	hasCosmos: boolean;

	obtenerNumeroBl(bl_detalle: bl, index) {
		this.index_bl = index;
		this.detalle_bl = new bl();
		this.detalle_bl = this.ls_bl[index];

		this.enviar = new sendContenedor();
		this.ls_contenedores_detalle = new Array<Contenedor>();

		this.enviar.blHijo = bl_detalle.documento;
		this.enviar.tipoBl = "M";
		this.enviar.codigoLocacion = bl_detalle.codigoLocacion;
		this.enviar.codigoNave = bl_detalle.codigoNave;
		this.enviar.nroManifiesto = bl_detalle.nroManifiesto.split("-")[1];
		this.enviar.anioManifiesto = bl_detalle.nroManifiesto.split("-")[0];
		this.enviar.ruc = this.usuario.rucEmpresa;
		this.enviar.tipoServicio = "1";
		this.enviar.numeroViaje = bl_detalle.numeroViaje;
		this.enviar.codigoRumbo = bl_detalle.codigoRumbo;
		this.enviar.codigoRegimen = bl_detalle.codigoRegimen;
		this.enviar.usuario = this.usuario.usuarioCuenta;
		this.enviar.transsaccionId = bl_detalle.transaccionId;

		this.impo.getDetalleBl(this.enviar)
			.subscribe(resp => {
				if (this.abrir_detalle == false) {
					this.abrir_detalle = true;
				}
				this.hasCosmos = false;
				this.ls_contenedores = resp;
				for (var i = 0; i < this.ls_contenedores.length; i++) {
					if (this.ls_contenedores[i].facturaCosmos && this.ls_contenedores[i].facturaCosmos.length > 0) {
						this.hasCosmos = true;
					}
				}

				if (this.detalle_bl.transaccionId != 0 && this.detalle_bl.codigoEstado == 3)
					this.obtener_detalle_liquidacion(this.detalle_bl.transaccionId);
			}, error => {
				this.sms.enviarAlerta({ mensaje: error, tipo: 3 })
			})
	}


	//Detalles del contenedor
	detalle_contenedor = new Contenedor();
	ls_detalle: Array<any>;
	ls_contenedores_detalle = new Array<Contenedor>();
	obtenerDetalle(contenedor: Contenedor, index) {
		this.detalle_contenedor = contenedor;

		if (!this.verificarLista(contenedor.nroContenedor)) {
			for (var i = 0; i < this.ls_contenedores.length; i++) {
				if (this.ls_contenedores[i].nroContenedor == contenedor.nroContenedor) {
					this.ls_contenedores[i].check = true;
					this.ls_contenedores_detalle.push(this.ls_contenedores[i]);
				}
			}
		}
	}

	verificarLista(valor) {
		var retorno = false;
		for (var i = 0; i < this.ls_contenedores_detalle.length; i++) {
			if (this.ls_contenedores_detalle[i].nroContenedor == valor) {
				this.ls_contenedores_detalle[i].check = false;
				this.ls_contenedores_detalle.splice(i, 1);
				retorno = true;
			}
		}
		return retorno;
	}

	cargando_act = false;
	obtenerActividad(ct: Contenedor) {
		this.ls_actividad = new Array<Actividad>();
		if (ct.codigoEstDetalle != 0 && ct.codigoEstDetalle != 3 && ct.codigoEstDetalle != 12) {
			this.getActividades(ct);
		}
		else this.cargando_act = false;

		if (ct.codigoEstDetalle != 0 && this.detalle_contenedor.nroContenedor) {
			this.getServiciosAd(this.detalle_bl, ct);
			this.impo.getTransportistas(this.detalle_bl, ct, 2).subscribe(resp => {
				this.ls_detalleTransportista = resp;
			});
		}
	}

	ls_actividad: Array<Actividad>
	getActividades(ct: Contenedor) {
		this.cargando_act = true;
		this.impo.getActividad(ct.transaccionId)
			.subscribe(resp => {
				this.cargando_act = false;
				this.ls_actividad = resp;

				this.ls_actividad.sort((a, b) => {
					var dateA: any = new Date(a.fechaAct.split(" ").join("T")), dateB: any = new Date(b.fechaAct.split(" ").join("T"))
					return dateA - dateB;
				})
			}, error => {
				this.cargando_act = false;
			})
	}



	/**
	 * OBTENER SERVICIOS ADICIONALES
	 */

	ls_serv_adicionales: Array<ServicioAdicinal>;

	getServiciosAd(bl: bl, ct: Contenedor) {
		this.ls_serv_adicionales = [];
		this.impo.getServiciosAdicionales(this.detalle_bl, ct)
			.subscribe(resp => {
				this.ls_serv_adicionales = resp;
				if (String(this.index_contenedor) && ct.codigoEstDetalle == 0) {
					if (this.ls_contenedores[this.index_contenedor].ls_servicios.length > 0)
						this.validar_servicios_seleccionados();
				}
			});
	}


	validar_servicios_seleccionados() {
		for (let i in this.ls_serv_adicionales) {
			for (let f in this.ls_contenedores[this.index_contenedor].ls_servicios) {
				if (this.ls_contenedores[this.index_contenedor].ls_servicios[f].checked == true) {
					if (this.ls_contenedores[this.index_contenedor].ls_servicios[f].codigoServicio == this.ls_serv_adicionales[i].codigoServicio) {
						this.ls_serv_adicionales[i].checked = true;
					}
				}
			}
		}
	}


	index_contenedor;
	abrir_modal_servicio(ct: Contenedor, index) {
		this.index_contenedor = index;
		this.getServiciosAd(this.detalle_bl, ct);
		$("#anadir-adicional").modal("show");
	}

	guardarServicioAdicional(ls_adicional: Array<ServicioAdicinal>) {
		var ls_serv = new Array<ServicioAdicinal>();
		for (var i = 0; i < ls_adicional.length; i++) {
			if (ls_adicional[i].checked == true) {
				ls_serv.push(ls_adicional[i]);
			}
		}

		if (ls_serv.length > 0) {
			this.ls_contenedores[this.index_contenedor].ls_servicios = ls_serv;
			$("#anadir-adicional").modal("hide");
		} else {
			this.alert("Debe seleccionar al menos un servicio adicional.")
		}
	}

	cancelarAdicional() {
		this.ls_contenedores[this.index_contenedor].check = false;
		this.ls_contenedores[this.index_contenedor].ls_servicios = [];
	}

	/**
	 * OBTENER TRANSPORTISTAS
	 */

	ls_transportista: Array<Transportista>;
	getTransportista(bl: bl, ct: Contenedor, opcion, call?: any) {

		this.ls_transportista = Array<Transportista>();
		$("#anadir-transportista").modal("show");

		let _data: any = this.cseCore.data['cse_transporters_' + opcion];
		if (_data) {
			this.ls_transportista = _data;
			if (call) {
				call();
			}
		} else {
			this.impo.getTransportistas(bl, ct, opcion).subscribe(resp => {
				this.cseCore.data['cse_transporters_' + opcion] = resp;
				this.ls_transportista = resp;
				if (call) {
					call();
				}
			});
		}
	}

	abrir_modal_transporte(e: any, dc: Contenedor, index) {
		e.preventDefault();
		e.stopPropagation();
		this.brand = ""
		this.abrir_detalle_info = false;
		if (dc != null) {
			this.detalle_contenedor = dc;
		}
		this.index_contenedor = index;
		if (this.detalle_bl.codigoEstado == 3 || this.detalle_bl.codigoEstado == 5 || this.detalle_bl.codigoEstado == 6) {
			this.getTransportista(this.detalle_bl, dc, 1, () => {
				this.impo.getTransportistas(this.detalle_bl, dc, 2).subscribe(resp => {
					this.brand = resp[0].rucEmpresa + "-" + resp[0].razonSocialEmpresa;
				});
			});
		} else {
			if (index == -1) {
				dc = new Contenedor();
				dc.transaccionId = "0";
			} else if (this.ls_contenedores[this.index_contenedor].ruc_transportista && this.ls_contenedores[this.index_contenedor].ruc_transportista != "") {
				this.brand = this.ls_contenedores[this.index_contenedor].ruc_transportista + "-" + this.ls_contenedores[this.index_contenedor].raz_transportista;
			}

			this.getTransportista(this.detalle_bl, dc, 2);
		}
	}


	guardarTransportista(transportista) {
		var tr = new Transportista();

		for (let i in this.ls_transportista) {
			if (transportista.transportista.split("-")[0] == this.ls_transportista[i].rucEmpresa) {
				tr.rucEmpresa = this.ls_transportista[i].rucEmpresa;
				tr.razonSocialEmpresa = this.ls_transportista[i].razonSocialEmpresa;
			}
		}

		if (this.detalle_bl.codigoEstado == 0) {

			this.cargarTransportista(tr);

		} else if ((this.detalle_bl.codigoEstado == 3 || this.detalle_bl.codigoEstado == 5 || this.detalle_bl.codigoEstado == 6) && (this.detalle_contenedor.codigoEstDetalle == 11 || this.detalle_contenedor.codigoEstDetalle == 12 || this.detalle_contenedor.codigoEstDetalle == 13 || this.detalle_contenedor.codigoEstDetalle == 14 || this.detalle_contenedor.codigoEstDetalle == 15)) {

			this.impo.modificarTransportista(this.detalle_contenedor, tr)
				.subscribe(resp => {
					if (resp.codigo == "0")
						this.alert(resp.mensaje);
					else if (resp.codigo == "1") {
						this.success(resp.mensaje);
						this.cargarTransportista(tr);
						this.obtenerNumeroBl(this.detalle_bl, this.index_bl);
						this.obtenerActividad(this.detalle_contenedor);
					}

				}, error => { this.error(error) })
		} else {
			this.success("No se puede actualizar el Transportista al contenedor con estado " + this.detalle_contenedor.estado);
		}

		$("#anadir-transportista").modal("hide");
		this.brand = "";
	}

	cargarTransportista(tr: Transportista) {
		if (this.index_contenedor == -1) {
			for (var i in this.ls_contenedores) {
				this.ls_contenedores[i].ruc_transportista = tr.rucEmpresa;
				this.ls_contenedores[i].raz_transportista = tr.razonSocialEmpresa;
			}
		} else {
			this.ls_contenedores[this.index_contenedor].ruc_transportista = tr.rucEmpresa;
			this.ls_contenedores[this.index_contenedor].raz_transportista = tr.razonSocialEmpresa;
		}
	}

	cancelarTransportista() {
		this.ls_contenedores[this.index_contenedor].check = false;
		this.ls_contenedores[this.index_contenedor].ruc_transportista = "";
		this.ls_contenedores[this.index_contenedor].raz_transportista = "";
		this.brand = "";
	}


	/**
	 * OBTENER CLIENTES A PAGAR
	 */

	ruc_cliente_facturar = "";
	raz_cliente_facturar = "";
	ls_clientes: Array<Cliente>;
	getClientes() {
		this.eid = 1;
		if (this.verificarTransportistas() == true) {
			this.formulario = true;
			$("#liquidar").modal("show")
			this.impo.getClientePago(this.detalle_bl.codigoLocacion, this.usuario.rucEmpresa, this.detalle_bl.codigoConsignatario)
				.subscribe(resp => {
					this.ls_clientes = resp;
					this.liquidar.cliente = this.ls_clientes[0].rucClienteFacturar;
					this.obtenerMoneda(this.ls_clientes[0].rucClienteFacturar);
				}, error => this.error(error));
		}
	}

	/**
	 * OBTENER MONEDA Y COMPROBANTE DE CLIENTE A PAGAR
	 */

	ls_monedas: Array<Moneda>;
	ls_comprobantes: Array<Comprobante>;
	obtenerMoneda(cliente) {
		this.ruc_cliente_facturar = cliente;
		for (let i = 0; i < this.ls_clientes.length; i++) {
			if (cliente == this.ls_clientes[i].rucClienteFacturar) {
				this.raz_cliente_facturar = this.ls_clientes[i].razonSocialClienteFacturar;
			}
		}


		this.ls_monedas = new Array<Moneda>();
		this.ls_comprobantes = new Array<Comprobante>();
		this.impo.getMonedaCliente(cliente, this.usuario.rucEmpresa, this.detalle_bl.codigoLocacion, this.detalle_bl.linea)
			.subscribe(resp => {
				this.ls_monedas = resp.listadoMoneda;
				this.liquidar.moneda = this.ls_monedas[0].tipoMoneda;
				this.ls_comprobantes = resp.listadoDocumento;
				this.liquidar.comprobante = this.ls_comprobantes[0].tipoDocumento;
			}, error => this.error(error));
	}


	transaccion: Transaccion = new Transaccion();
	liquidar: Liquidacion = new Liquidacion();
	liquidando = false;
	generarLiquidacion(liquidacion: Liquidacion) {
		if (this.verificarTransportistas() == true) {
			this.detalle_bl.tipoBl = this.busqueda.tipoBl;
			this.generarTransaccion(liquidacion, this.detalle_bl, this.ls_contenedores);

		}

	}

	detalleDescripImpo: any = [];
	monto_transaccion: number = 0.00;
	generarTransaccion(liquidacion: Liquidacion, detalle_bl: bl, ls_contenedores: Array<Contenedor>) {
		this.liquidando = true;
		this.impo.liquidarPago(liquidacion, detalle_bl, ls_contenedores)
			.subscribe(resp => {
				this.detalleDescripImpo = [];
				this.success("--Transaccion generada--");
				this.getNotasCredito(liquidacion, this.detalle_bl);

				this.transaccion.montoPagar = resp[0].montoPagar;
				this.transaccion.revelarMonto = resp[0].revelarMonto;
				this.transaccion.simboloMoneda = resp[0].simboloMoneda;
				this.transaccion.tipoCliente = resp[0].tipoCliente;
				this.transaccion.transaccionID = resp[0].transaccionID;

				this.detalleDescripImpo = resp[1];
				for (var i in this.detalleDescripImpo) {
					this.totalDD += this.detalleDescripImpo[i][6];
				}

				if (this.transaccion.tipoCliente == "4") {
					this.n_opcion = 0;
				}
				if (this.transaccion.tipoCliente == "3") {
					this.con_saldo = false;
				}
				this.formulario = false;
				this.liquidando = false;

				this.monto_transaccion = Number(this.transaccion.montoPagar);
				this.monto_real = this.transaccion.montoPagar;
			}, error => {
				this.alert(error);
				this.liquidando = false;
				this.formulario = true;
			});
	}

	ls_notas_credito: Array<NotaCredito>;

	getNotasCredito(liquidacion: Liquidacion, detalle_bl: bl) {
		this.impo.getNotasCredito(liquidacion, detalle_bl)
			.subscribe(resp => {
				this.ls_notas_credito = resp.listaNotaCredito;
			})
	}

	monto_real: string = "";
	ls_notas_agregado = new Array<NotaCredito>();
	agregarNotas(nota: NotaCredito, index) {

		if (this.ls_notas_agregado.indexOf(nota) !== -1) {
			this.monto_transaccion = Number((Number(this.monto_transaccion) + Number(nota.monto)).toFixed(2));
			this.monto_real = String(Number(this.monto_transaccion).toFixed(2));
			this.ls_notas_agregado.splice(this.ls_notas_agregado.indexOf(nota), 1)
			//console.log("eliminado");
			//console.log(JSON.stringify(this.ls_notas_agregado));
		} else {
			if (Number(this.monto_transaccion) >= Number(nota.monto)) {
				this.monto_transaccion = Number((Number(this.monto_transaccion) - Number(nota.monto)).toFixed(2));
				this.monto_real = String(Number(this.monto_transaccion).toFixed(2));
				this.ls_notas_agregado.push(nota);
				//console.log("agregado");
				//console.log(JSON.stringify(this.ls_notas_agregado))
			} else {
				this.ls_notas_credito[index].check = false;
				this.alert("No se puede agregar");
			}
		}
	}


	formulario: boolean = false;
	cancelando: boolean = false;

	cancelarTransaccion(transaccionId, tipoCliente) {
		this.eid = 1;
		this.cancelando = true;

		if (transaccionId == "" && tipoCliente == "") {
			this.success("No se ha generado ninguna Transaccion ... ");
			this.cerrarLiquidar();
		} else {
			this.impo.cancelarTransaccion(transaccionId, tipoCliente)
				.subscribe(resp => {
					this.success(resp.mensaje);
					this.cerrarLiquidar();
				}, error => {
					this.cancelando = false;
					this.error(error);
				})
		}
	}


	n_opcion: number = 0;
	pago_completado: boolean = false;
	cerrarLiquidar() {
		this.liquidando = false;
		this.cancelando = false;
		this.liquidado = false;
		this.ls_notas_credito = new Array<NotaCredito>();
		this.transaccion = new Transaccion();
		this.pago = new Pago();

		this.pago_completado = false;
		this.tipocliente = "";
		this.siguientetres = "";
		this.n_opcion = 0;


		this.monto_transaccion = 0.00;
		this.monto_real = "";

		for (let i in this.ls_bl) {
			if (this.ls_bl[i].documento = this.detalle_bl.documento)
				this.detalle_bl = this.ls_bl[i];
		}

		$("#liquidar").modal("hide");
	}


	verificarTransportistas() {
		var ok: boolean = false;
		var cnt = [];
		for (let i = 0; i < this.ls_contenedores.length; i++) {
			if (this.ls_contenedores[i].ruc_transportista != "") {
				ok = true
			} else {
				ok = false;
				cnt.push(this.ls_contenedores[i].nroContenedor);
			}
		}
		if (cnt.length > 0) {
			this.alert("Para Liquidar un BL, Primero tiene que asignar una empresa  a los contenedores: " + cnt.join(", "));
		}
		return ok;
	}





	eid: number;
	pago: Pago = new Pago();
	generando = false;
	generarCodigopago(transaccion: Transaccion) {
		this.eid = 1;
		this.generando = true;
		this.pago_completado = false;

		if (this.siguientetres == '3') {
			transaccion.tipoCliente = '2';
		}

		if (this.tipocliente == "5") {
			transaccion.tipoCliente = '2';
		}

		this.cseCore.getLoader().show();
		this.impo.generarCodigoPago(transaccion, this.ls_notas_agregado)
			.subscribe(resp => {
				this.success("El pago ha sido generado correctamente..");
				this.pago = resp;
				this.generando = false;
				this.liquidado = true;
				if (transaccion.tipoCliente == "1") {
					this.cerrarLiquidar();
				} else if (transaccion.tipoCliente == "2") {
					this.pago_completado = true;
				} else if (transaccion.tipoCliente == "3") {
					this.cerrarLiquidar();
				} else if (transaccion.tipoCliente == "4") {
					this.cerrarLiquidar();
				} else if (transaccion.tipoCliente == "5") {
					this.pago_completado = true;
				}

				this.generando = false;
				this.BUSCAR(this.busqueda, this.tipo_busqueda);

				this.cseCore.getLoader().close();
			}, error => {
				this.pago_completado = false;
				this.generando = false;
				this.liquidado = false;
				this.error(error)
			})

	}
	totalDD: number;
	detalleDescrip: any = [];
	detalleLiquidacion: DetalleLiquidacion = new DetalleLiquidacion();
	obtener_detalle_liquidacion(transaccionId) {
		this.impo.obtener_liquidacion(transaccionId).subscribe(resp => {

			this.detalleLiquidacion.simboloMoneda = resp[0][3];
			this.detalleLiquidacion.monto = resp[0][2];
			this.detalleLiquidacion.cliente = resp[0][4];
			this.detalleLiquidacion.moneda = resp[0][5];
			this.detalleLiquidacion.tipoComprobante = resp[0][6];
			this.detalleLiquidacion.ruc = resp[0][7];
			this.detalleLiquidacion.razSocial = resp[0][8];

			this.detalleDescrip = [];
			this.detalleDescrip = resp[1];

			this.totalDD = 0;
			for (var i in this.detalleDescrip) {
				this.totalDD += this.detalleDescrip[i][6];
			}

		}, error => this.alert(error));

	}

	abrir_detalle_liquidacion() {
		$('#detalles-liquidacion').modal("show");
	}








	//GENERAR CITAS DE LOS BLS SELECCIONADOS
	abrirCita(tipo_cita) {
		$(".bd-example-modal-lg2").modal("show");
		this.traerCita(new Date());
		this.codigo_generar_cita = tipo_cita;
	}


	ls_cuadricula: Array<Cuadricula>;
	ls_cupo: Array<Cupo>;
	fecha_cita: Date;

	traerCita(fecha) {
		this.fecha_cita = fecha;
		this.getCuadriculaCitas(this.convertirFecha(fecha));
	}


	getCuadriculaCitas(fecha) {
		this.ls_cuadricula = new Array<Cuadricula>();
		this.impo.getCuadriculaCitas(this.usuario.rucEmpresa, this.usuario.usuarioCuenta, this.detalle_contenedor, this.detalle_bl, fecha)
			.subscribe(resp => {
				this.ls_cuadricula = resp;
				this.ls_cupo = new Array<Cupo>();
				this.impo.getCitasDisponibles(this.detalle_contenedor, this.detalle_bl, fecha)
					.subscribe(resp => {
						this.ls_cupo = resp;
						this.armar(this.ls_cupo);
					}, error => this.error(error))
			}, error => this.alert(error));
	}


	armar(ls_cupos: Array<Cupo>) {
		for (let i = 0; i < this.ls_cuadricula.length; i++) {
			var cupos = new Array<Cupo>();
			for (let f = 0; f < ls_cupos.length; f++) {
				if (ls_cupos[f].citaConfigID == this.ls_cuadricula[i].citaConfigId) {
					cupos.push(ls_cupos[f]);
				}
			}
			this.ls_cuadricula[i].cupos = cupos;
		}
	}



	error(mensaje) {
		this.sms.enviarAlerta({ mensaje: mensaje, tipo: 2 })
	}
	success(mensaje) {
		this.sms.enviarAlerta({ mensaje: mensaje, tipo: 1 })
	}
	alert(mensaje) {
		this.sms.enviarAlerta({ mensaje: mensaje, tipo: 3 })
	}
	info(mensaje) {
		this.sms.enviarAlerta({ mensaje: mensaje, tipo: 4 })
	}

	es;
	hoy: Date = new Date();
	usuario: Usuario;

	liquidado = false;
	carga_completa = false;
	pagina_actual = 1;
	pagina_total = 0;
	total_item = 0;

	ir_pagina(pagina) {
		this.pagina_actual = pagina;
		this.busqueda.pagina = pagina;
		this.BUSCAR(this.busqueda, this.tipo_busqueda)
	}


	ngOnInit() {
		this._titulo.setTitle("Container Services | Impo");
		this.show_arv = false;
		this.ls_paginas = [];
		this.cargando_act = false;
		this.total_item = 0;
		this.pagina_total = 1;
		this.tipo_busqueda = 2;
		this.busqueda.pagina = this.pagina_actual;


		this.liquidando = false;
		this.liquidado = false;
		this.abrir_detalle = false;
		this.abrir_avanzado = false;
		this.usuario = JSON.parse(localStorage.getItem("usuario"));
		this.es = es;
		this.fecha_cita = new Date();
		this.ls_citas = new Array<Cita>();
		this.busqueda.tipoBl = this.ls_tiposBL[0].codigo;
		this.busqueda.manifiesto = "";
		this.busqueda.estadoBl = this.ls_liquidados[0].codigo;
		this.busqueda.numeroBl = "";
		//this.busqueda.numeroBl = "SUDUN7465A58M815";
		//this.busqueda.numeroBl = "ANRM67910A31O6D0";

		//this.busqueda.numeroBl = "SUDUN7465A52R508";
		//this.busqueda.numeroBl = "SUDUN7998A52R6X5";
		this.detalle_bl.documento = "";
		$(".text-header").text("Impo Devolucion / Buscar BL");
		this.carga_completa = false;

		this.obtenerBLDefecto(this.busqueda);
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
		this.subscription_delete.unsubscribe();

		try {
			$(".datepicker-container").remove();
		} catch (error) {
			console.log(error)
		}
	}

	convertirFecha(str: string) {
		var date = new Date(str),
			year = date.getFullYear(),
			mnth = ("0" + (date.getMonth() + 1)).slice(-2),
			day = ("0" + date.getDate()).slice(-2);
		return year + mnth + day;
	}

	ngAfterViewInit() {
		/*
			$('.date-picker').datepicker({
				language: "es",
				format: 'dd/mm/yyyy',
			});
		*/
		$('.date-picker').datepicker({ language: 'es-ES', format: 'dd/mm/yyyy' });
	};


	ls_paginas = [];
	crear_paginacion(total_paginas) {
		this.ls_paginas = [];
		var curr = 1;

		while (total_paginas + 1 > curr) {
			this.ls_paginas.push(curr)
			curr++;
		}
	}


	show_arv = false;
	cont_cita: Contenedor = new Contenedor();
	ver_arv(cnt: Contenedor) {
		this.cont_cita = cnt;
		this.show_arv = true;

		window.open(url_form, "", "width=600,height=600");
	}

	cerrar_avr(event) {
		//console.log(event);
		if (event == false) {
			$("#detalle-arv").modal("hide");
			setTimeout(() => {
				this.show_arv = false;
				this.cont_cita = new Contenedor();
			}, 200)
		}
	}

	cerrarDetalle() {
		this.ls_bl[this.index_bl] = this.detalle_bl;
		this.abrir_detalle = false;
		this.abrir_detalle_info = false;
		this.detalle_bl = new bl();
		this.detalle_contenedor = new Contenedor();
		this.ls_contenedores_detalle = new Array<Contenedor>();

		this.nom_factura = "";
		this.url_factura = "";
		this.arc_factura = new Blob;
		this.brand = "";
		this.tipocliente = "";
		this.siguientetres = "";
		this.n_opcion = 0;
		//this.index_bl = "";
		this.liquidado = false;
		this.detalleLiquidacion = new DetalleLiquidacion();
		this.pago = new Pago();
		this.transaccion = new Transaccion();

		//this.BUSCAR(this.busqueda);
	}

	ver_pdf(numero, serie, tipo) {
		//if (this.nom_factura == "") {
		var com = new PDF();
		com.Numero = numero;
		com.Serie = serie;
		com.TipoComprobante = tipo;

		this.impo.get_comprobante_pdf(com)
			.subscribe(resp => {
				var xml_file = new Blob([resp], { type: 'text/xml' });
				var xml = URL.createObjectURL(xml_file);
				this.xmlParser(xml)
			}, error => {
				//console.log(error)
			})
		/*} else {
			$(".bd-example-modal-lg").modal("show");
		}*/
	}



	nom_factura = "";
	url_factura = "";
	arc_factura: Blob;

	xmlParser(xml) {
		var request = new XMLHttpRequest();
		request.open("GET", xml, false);
		request.send();
		var text = request.responseXML;

		if (text.getElementsByTagName("NombrePDF").length > 0) {
			var nombre_pdf = text.getElementsByTagName("NombrePDF");
			var nombre = nombre_pdf[0].innerHTML;
		}

		if (text.getElementsByTagName("ArchivoPDF").length > 0) {
			var archivo_pdf = text.getElementsByTagName("ArchivoPDF");
			var archivo = archivo_pdf[0].innerHTML;
		}

		if (text.getElementsByTagName("Cadena").length > 0) {
			var mensaje_error = text.getElementsByTagName("Cadena");
			var mensaje = mensaje_error[0].innerHTML;
		}

		if (mensaje == "") {
			this.url_factura = URL.createObjectURL(this.convertir_binario(archivo, "application/pdf"));
			this.arc_factura = this.convertir_binario(archivo, "application/pdf")
			this.nom_factura = nombre;
			$(".bd-example-modal-lg").modal("show");
		} else {
			this.error(mensaje)
		}
	}


	convertir_binario(b64Data, contentType) {
		contentType = contentType || '';
		var sliceSize = 512;
		b64Data = b64Data.replace(/^[^,]+,/, '');
		b64Data = b64Data.replace(/\s/g, '');
		var byteCharacters = atob(b64Data);
		var byteArrays = [];

		for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			var slice = byteCharacters.slice(offset, offset + sliceSize);

			var byteNumbers = new Array(slice.length);
			for (var i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			var byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		var blob = new Blob(byteArrays, { type: contentType });

		return blob;
	}

	codigo_liquidacion: string = "";
	fecha_liquidacion: string = "";
	ruc_facturar: string = "";
	razon_facturar: string = "";
	monto_facturar: string = "";
	moneda_facturar: string = "";

	abrir_compartir(codigo_liquidacion, fecha_liquidacion, ruc_facturar, razon_facturar, monto_facturar, moneda_facturar) {
		this.codigo_liquidacion = codigo_liquidacion;
		this.fecha_liquidacion = fecha_liquidacion;

		this.ruc_facturar = ruc_facturar;
		this.razon_facturar = razon_facturar;
		this.monto_facturar = monto_facturar;
		this.moneda_facturar = moneda_facturar;

		$('#enviar-correo').modal('show');
	}

	imprimirVoucher() {
		var contenido = document.getElementById("areaImpresa").innerHTML;
		var contenidoOriginal = document.body.innerHTML;
		print();
	}

	@ViewChild("tableA") tableA: ElementRef;
	ngAfterContentChecked(): void {
		if (this.tableA) {
			this.renderizar(window.innerHeight, window.innerWidth);
		}
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.renderizar(event.target.innerHeight, event.target.innerWidth);
	}

	renderizar(height: number, width: number) {
		var realHeight = 0;
		if (height < 480) {
			realHeight = 300;
		} else {
			var miHeight = 0;
			if (width < 768) {
				miHeight = 275;
			} else {
				miHeight = 364;
			}
			realHeight = (height - miHeight)
		}
		if (this.tableA) {
			this.tableA.nativeElement.style["max-height"] = realHeight + "px";
		}

	}

}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/view/impo/impo.component.ts